import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslations } from 'next-intl';
import Link from 'next/link';

import { Alert, Button } from '@zealy/design-system';
import { ArrowRightLine } from '@zealy/icons';

import { useDebouncedValue } from '#hooks/useDebouncedValue';

import type { APITask } from './APITests.const';
import { useError } from '../../../../../FormError.context';
import { APITests } from './APITests';
import { runTests } from './APITests.utils';

export const API = ({ name, type }: { name: string; type?: string }) => {
  const t = useTranslations('common');

  const { watch } = useFormContext();

  const { setError, clearError } = useError(name);

  const fields: APITask['settings'] = watch(name);

  const debouncedEndpoint = useDebouncedValue(fields.endpoint, 500);

  const isOnChainType = type === 'onChain';

  return (
    <>
      <APITests
        fields={{
          ...fields,
          endpoint: debouncedEndpoint,
        }}
        setError={(message?: string) => {
          if (!message) clearError();
          else setError(message);
        }}
        runTests={runTests}
      />

      <Button
        size="sm"
        variant="ghost"
        mutedText
        rightIcon={<ArrowRightLine />}
        as={Link}
        href="/docs/tasks/api"
        className="self-start"
      >
        {t('documentation')}
      </Button>

      {isOnChainType && (
        <Alert
          variant="info"
          title="Need a custom on-chain integration?"
          description={
            <Link
              href="https://zealy.io/enterprise"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-50 text-primary hover:text-brand-primary transition-colors underline-offset-2 hover:underline"
            >
              Explore our enterprise offering
              <ArrowRightLine size={14} />
            </Link>
          }
        />
      )}
    </>
  );
};
